import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  GetSubsidyOptions,
  GetSubsidyRequest,
  GetSubsidyRequestSchema,
  GetSubsidyResponse,
  GetSubsidyResponseSchema,
} from './get-subsidy.types';

export function getSubsidy(
  baseUrl: string,
  body: GetSubsidyRequest,
  options?: GetSubsidyOptions,
): Promise<IHttpResponse<GetSubsidyResponse>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<GetSubsidyRequest> = {
    url: `${baseUrl}/api/quotes-api/v1/subsidy`,
    method: 'POST',
    headers,
    body,
    schemas: {
      request: GetSubsidyRequestSchema,
      response: GetSubsidyResponseSchema,
    },
    ...restOptions,
  };

  return httpCall<GetSubsidyRequest, GetSubsidyResponse>(request);
}
